import { createSlice } from '@reduxjs/toolkit';
import { WhiteLabelState } from '../types';
import { fetchWhiteLabelConfig } from './actions';

const initialState: WhiteLabelState = {
  config: null,
  loading: false,
  error: null,
};

export const whiteLabelSlice = createSlice({
  name: 'whiteLabel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWhiteLabelConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWhiteLabelConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload;
        state.error = null;
      })
      .addCase(fetchWhiteLabelConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch white label config';
      });
  },
});

export default whiteLabelSlice;
